import React from 'react';

const Chevron = ({ direction, isEnabled, onClick }) => {
  const dir = direction === 'left' ? -1 : 1;
  const enabled = isEnabled ? 'En' : 'Dis';
  const handleClick = () => onClick && onClick(dir);

  return (
    <div
      className={`chevron chevron--${direction} chevron--is${enabled}abled`}
      onClick={handleClick}
    >
      <svg
        width="8"
        height="13"
        viewBox="0 0 8 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 12.5L7 6.5L1 0.5"
          stroke="#01435C"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default Chevron;
